import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FinancePie from "../../charts/FinancePie/FinancePie";
import {
  legendsData,
  generatePieData,
} from "../../../utils/chartsData/pieData";
import arrowDownIcon from "../../../assets/images/arrow-down.png";
import arrowUpIcon from "../../../assets/images/arrow-up.png";
import arrowLeftIcon from "../../../assets/images/arrow-left.png";

import PensionValuesTable from "./PensionValuesTable/PensionValuesTable";
import { useHistory } from "react-router-dom";

// import * from "../../../utils/helpers/dateFormatter" as DateUtil
import {
  dateDotFormat,
  dateMonthFormat,
} from "../../../utils/helpers/dateFormatter";
import { fixedTwoDigitsNumber } from "../../Table/makeData";
import DashboardPensionOptionProps from "./DashboardPensionOptionProps";
import { numberWithCommas } from "../../../utils/helpers/numberConverter";
import "./DashboardPensionOption.scss";
import RightsPerEmpData from "../../../entities/RightsPerEmpData";
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import DashboardItem from "../DashboardTopItem/DashboardTopItem";
import DashboardBottomItem from "../DashboardBottomItem/DashboardBottomItem";


//TODO remove duplication by divide screens, and separate logic

const DashboardPensionOption = (props: DashboardPensionOptionProps) => {
  const history = useHistory();
  const { t, i18n } = useTranslation("common");
  const [isExpanded, setExpanded] = useState(false);

  const getTotalDeposit = () => {
    if (props.lastDeposit) {
      return fixedTwoDigitsNumber(
        props?.lastDeposit?.tranEmployeeSum +
        props?.lastDeposit?.tranEmployerSum +
        props?.lastDeposit?.tranCompensationSum +
        props?.lastDeposit?.tranDifferentSum
      );
    }
  };

  const getUnPensionAmount = () => {
    if (props.unRedemptionRightData) {
      return numberWithCommas(
        Math.floor(
          props?.unRedemptionRightData?.employeeSum +
          props?.unRedemptionRightData?.employerSum +
          props?.unRedemptionRightData?.compensationSum
        )
      );
    }
  };

  const openDepositsPage = () => {
    history.push("/deposits");
  };

  const getFixedRightsForEmp = (rightsPerEmp: RightsPerEmpData[]) => {
    if (rightsPerEmp?.length)
      return rightsPerEmp.map((rightPerEmp: RightsPerEmpData) => ({
        ...rightPerEmp,
        compensationSum: numberWithCommas(
          Math.floor(rightPerEmp.compensationSum)
        ),
        employeeSum: numberWithCommas(Math.floor(rightPerEmp.employeeSum)),
        employerSum: numberWithCommas(Math.floor(rightPerEmp.employerSum)),
      }));
    return [];
  };

  const isValidPensionData = () =>
    props?.userPensionData?.widowPensionPercent !== null ||
    props?.userPensionData?.widowPensionSum !== null ||
    props?.userPensionData?.orphanPensionSum !== null ||
    props?.userPensionData?.orphanPensionPercent !== null ||
    props?.userPensionData?.disabilityPensionPercent !== null ||
    props?.userPensionData?.disabilityPensionSum !== null;

  const isValidRedemptionData = () =>
    props?.redemptionRightData?.compensationSum ||
    props?.redemptionRightData?.employeeSum ||
    props?.redemptionRightData?.employerSum;

  return (
    <>
      <div className="dashboard-kitzva-details desktop">
        {props?.userPensionData?.accumulatedPensionAmount !== null ? (
          <>
            {/* קצבה צבורה */}
            <DashboardItem
              title={t("Dashboard.sumKitzva")}
              symbol={"₪"}
              value={props?.userPensionData?.accumulatedPensionAmount}
              subString={`${t("Dashboard.sumKitzvaExplain")} ${props.userPensionData.retirementAge
                }`}
              toolTip={`${t("Dashboard.dateValidity")} ${dateDotFormat(
                props?.userPensionData?.dolValidityDate
              )}`}
            />
            {/* אחוזי צבורה */}
            <DashboardItem
              title={t("Dashboard.percentKitzva")}
              symbol={"%"}
              value={props?.userPensionData?.accumulatedPensionPercent}
              isToShowFully={true}
              subString={t("Dashboard.maxPensionPercent")}
            />
          </>
        ) : (
          <>
            {/* אחוזי צבורה */}
            <DashboardItem
              title={t("Dashboard.percentKitzva")}
              symbol={"%"}
              value={props?.userPensionData?.accumulatedPensionPercent}
              isToShowFully={true}
              subString={t("Dashboard.maxPensionPercent")}
            />
          </>
        )}
        {/* תקופת חברות בקרן */}
        {props?.userPensionData?.membershipPeriod !== null ? (
          <DashboardItem
            title={t("Dashboard.membership")}
            month={t("general.months")}
            value={props?.userPensionData?.membershipPeriod}
          />
        ) : null}
      </div>

      {/* mobile */}
      <div className="dashboard-funds-details mobile">
        <div className="d-flex">
          {props?.userPensionData?.accumulatedPensionAmount !== null ? (
            <>
              {/* קצבה צבורה */}
              <DashboardItem
                title={t("Dashboard.sumKitzva")}
                symbol={"₪"}
                value={props?.userPensionData?.accumulatedPensionAmount}
                subString={`${t("Dashboard.sumKitzvaExplain")} ${props.userPensionData.retirementAge
                  }`}
                toolTip={`${t("Dashboard.dateValidity")} ${dateDotFormat(
                  props?.userPensionData?.dolValidityDate
                )}`}
              />
              {/* אחוזי צבורה */}
              <DashboardItem
                title={t("Dashboard.percentKitzva")}
                symbol={"%"}
                value={props?.userPensionData?.accumulatedPensionPercent}
              isToShowFully={true}
              subString={t("Dashboard.maxPensionPercent")}
              />
            </>
          ) : (
            <DashboardItem
              title={t("Dashboard.percentKitzva")}
              symbol={"%"}
              value={props?.userPensionData?.accumulatedPensionPercent}
              subString={t("Dashboard.maxPensionPercent")}
              isToShowFully={true}
              mobileHideLeftBorder={true}
            />
          )}
        </div>
        <div className="dashboard-fund-item d-flex">
          <div className="dashboard-fund-item-text">
            <span className="dashboard-fund-item-title">
              {t("Dashboard.membership")} <span className="mobile">:</span>
            </span>
          </div>
          <div className="fund-item-value-wrapper">
            <span className="dashboard-fund-item-value">
              {props?.userPensionData?.membershipPeriod || 0}
            </span>
            <span className="dashboard-bottom-month">
              {t("general.months")}
            </span>
          </div>
        </div>
      </div>

      <div
        className="dashboard-kitzva-details"
        style={{ display: `${!isValidPensionData() ? "none" : ""}` }}
      >
        {props?.userPensionData?.accumulatedPensionAmount === null ? (
          <>
            {/* קצבת נכות באחוזים */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaNechut")}`}
              value={props?.userPensionData?.disabilityPensionPercent}
              isShekel={false}
              isToShowFully={true}
              subString={t("Dashboard.kitzvaNechutPercentExplain")}
              toolTip={t("Dashboard.kitzvaNechutPercentExplain")}
            />

            {/* קצבת אלמן באחוזים */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaAlman")}`}
              value={props?.userPensionData?.widowPensionPercent}
              isShekel={false}
              isToShowFully={true}
              subString={t("Dashboard.kitzvaDeathPercent")}
              toolTip={t("Dashboard.kitzvaDeathPercent")}
            />
            {/* קצבת יתום באחוזים */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaYatom")}`}
              value={props?.userPensionData?.orphanPensionPercent}
              isShekel={false}
              isToShowFully={true}
              subString={t("Dashboard.kitzvaRestPercent")}
              toolTip={t("Dashboard.kitzvaRestPercent")}
            />
          </>
        ) : null}

        {props?.userPensionData?.accumulatedPensionAmount !== null ? (
          <>
            {/*  קצבת נכות סכום */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaNechut")}`}
              value={props?.userPensionData?.disabilityPensionSum}
              isShekel={true}
              subString={t("Dashboard.kitzvaNechutExplain")}
              toolTip={t("Dashboard.kitzvaNechutExplain")}
            />
            {/*  קצבת אלמן סכום */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaAlman")}`}
              value={props?.userPensionData?.widowPensionSum}
              isShekel={true}
              subString={t("Dashboard.kitzvaDeath")}
              toolTip={t("Dashboard.kitzvaDeath")}
            />
            {/*  קצבת יתום סכום */}
            <DashboardBottomItem
              title={`${t("Dashboard.kitzvaYatom")}`}
              value={props?.userPensionData?.orphanPensionSum}
              isShekel={true}
              subString={t("Dashboard.kitzvaRest")}
              toolTip={t("Dashboard.kitzvaRest")}
            />
          </>
        ) : null}
      </div>

      {isValidRedemptionData() ? (
        <div className="dashboard-pedion-rap">
          <div className="pension-values-button-expand">
            {!isExpanded ? (
              <>
                <button
                  className="btn-rm-st"
                  onClick={() => setExpanded(!isExpanded)}
                  onKeyPress={(event) =>
                    isEnterPress(event) && setExpanded(!isExpanded)
                  }
                  tabIndex={0}
                >
                  {t("general.moreDetails")}
                  <img src={arrowDownIcon} alt="down" />
                </button>
              </>
            ) : (
              <>
                <button
                  className="btn-rm-st"
                  onClick={() => setExpanded(!isExpanded)}
                  onKeyPress={(event) =>
                    isEnterPress(event) && setExpanded(!isExpanded)
                  }
                  tabIndex={0}
                >
                  {t("general.lessDetails")}
                  <img src={arrowUpIcon} alt="up" />
                </button>
              </>
            )}
          </div>
          <div id="dashboard-pedion-values" className="dashboard-pedion-values">
            <div className="pedion-values-header-wrapper">
              <h2 className="pedion-values-title">
                {t("Dashboard.pedionValues")}{" "}
              </h2>
              {/* <h2 className="pedion-values-subtitle">
                {t("Dashboard.maybeExplain")}
              </h2> */}
            </div>
            <div className={isExpanded ? "pedion-values-graph-open min-h-n" : "pedion-values-graph min-h-e"}>
              <div className="wrap-pie">
                {/* <div className="dashboard-graph-wrapper"> */}
                <div className={isExpanded ? "Pie-cl chert-an" : "Pie-cl chert-at"}>
                  {/* <div className="Pie-cl"> */}
                  <FinancePie
                    redemptionRightData={props.redemptionRightData}
                    height={273}
                    width={"100%"}
                    marginTop={0}
                    marginBottom={0}
                    marginLeft={0}
                    marginRight={0}
                    shekelSize={17}
                    valueSize={32}
                    labelSize={21}
                    xMove={13}
                  />
                </div>
                {/* {!isExpanded ? ( */}
                <ul className={isExpanded ? "visually-hidden" : "wrap-graph-data anm-t"} style={!isExpanded ? { opacity: 1, width: "auto", display: "block" } : { opacity: 0, width: 0, display: "none" }}>
                  {generatePieData(
                    props.redemptionRightData,
                    i18n.language
                  ).map((pieData, index) => {
                    return (
                      <li className="wrap-labels" key={index}>
                        <div
                          className="color"
                          style={{ backgroundColor: pieData.color }}
                        ></div>
                        <div className="d-flex align-tems-center justify-content-between content-width">
                          <span className="label">
                            {pieData?.label.split(":")[0]}: ₪{numberWithCommas(Math.floor(pieData?.value))}
                          </span>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                {/* ) : ( */}
                <div className={!isExpanded ? "visually-hidden" : ""} style={isExpanded ? { opacity: 1, width: "100%", margin: "auto", display: "block" } : { opacity: 0, width: "0", display: "none" }}>
                  <div className="dashboard-graph-wrapper">
                    <div className="wrap-graph-data list-data mobile-flex">
                      {generatePieData(props.redemptionRightData).map(
                        (pieData, index) => {
                          return (
                            <div className="list-labels" key={index}>
                              <div
                                className="color"
                                style={{ backgroundColor: pieData.color }}
                              ></div>
                              <div className="label">
                                {" "}
                                {pieData?.label.split(":")[0]}{" "}
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <PensionValuesTable
                      tableData={getFixedRightsForEmp(props.rightsPerEmp)}
                    />
                  </div>
                </div>
              </div>
              {Object.keys(props?.unRedemptionRightData).length && isExpanded ? (
                <div className="dashboard-graph-bottom">
                  <div className="dashboard-graph-bottom-right">
                    <span className="graph-right-bottom-label">
                      {t("Dashboard.notPensionSum")}
                    </span>
                    <div style={{ textAlign: "center" }}>
                      <span style={{ fontSize: "18px" }}>₪</span>
                      <span className="graph-right-bottom-value">
                        {getUnPensionAmount()}
                      </span>
                    </div>
                  </div>
                  <div className="dashboard-bottom-separator"></div>
                  <div className="dashboard-graph-bottom-left">
                    <div className="graph-left-bottom-wrapper">
                      <span className="graph-left-bottom-label">{`${t(
                        "Dashboard.insuredPart"
                      )}:`}</span>
                      <span className="graph-left-bottom-value">
                        {`${numberWithCommas(
                          Math.floor(
                            props?.unRedemptionRightData?.employeeSum
                          )
                        )} ₪`}{" "}
                      </span>
                    </div>
                    <div className="graph-left-bottom-wrapper">
                      <span className="graph-left-bottom-label">{`${t(
                        "Dashboard.employerPart"
                      )}:`}</span>
                      <span className="graph-left-bottom-value">{`${numberWithCommas(
                        Math.floor(
                          props?.unRedemptionRightData?.employerSum
                        )
                      )} ₪`}</span>
                    </div>
                    <div className="graph-left-bottom-wrapper">
                      <span className="graph-left-bottom-label">{`${t(
                        "Dashboard.awards"
                      )}:`}</span>
                      <span className="graph-left-bottom-value">{`${numberWithCommas(
                        Math.floor(
                          props?.unRedemptionRightData?.compensationSum
                        )
                      )} ₪`}</span>
                    </div>
                  </div>
                </div>
              ) : null}
              {/* )} */}
              {/* </div> */}
            </div>
          </div>

        </div>
      ) : !isValidRedemptionData() &&
        Object.keys(props?.unRedemptionRightData).length ? (
        <div id="dashboard-pedion-values" className="dashboard-pedion-values">
          <div className="pedion-values-header-wrapper">
            <span className="pedion-values-title">
              {t("Dashboard.pedionValues")}{" "}
            </span>
            {/* <span className="pedion-values-subtitle">
              {t("Dashboard.maybeExplain")}
            </span> */}
          </div>
          <div className="dashboard-graph-bottom">
            <div className="dashboard-graph-bottom-right">
              <span className="graph-right-bottom-label">
                {t("Dashboard.notPensionSum")}
              </span>
              <div style={{ textAlign: "center" }}>
                <span style={{ fontSize: "18px" }}>₪</span>
                <span className="graph-right-bottom-value">
                  {getUnPensionAmount()}
                </span>
              </div>
            </div>
            <div className="dashboard-bottom-separator"></div>
            <div className="dashboard-graph-bottom-left">
              <div className="graph-left-bottom-wrapper">
                <span className="graph-left-bottom-label">{`${t(
                  "Dashboard.insuredPart"
                )}:`}</span>
                <span className="graph-left-bottom-value">
                  {`${numberWithCommas(
                    Math.floor(props?.unRedemptionRightData?.employeeSum)
                  )} ₪`}{" "}
                </span>
              </div>
              <div className="graph-left-bottom-wrapper">
                <span className="graph-left-bottom-label">{`${t(
                  "Dashboard.employerPart"
                )}:`}</span>
                <span className="graph-left-bottom-value">{`${numberWithCommas(
                  Math.floor(props?.unRedemptionRightData?.employerSum)
                )} ₪`}</span>
              </div>
              <div className="graph-left-bottom-wrapper">
                <span className="graph-left-bottom-label">{`${t(
                  "Dashboard.awards"
                )}:`}</span>
                <span className="graph-left-bottom-value">{`${numberWithCommas(
                  Math.floor(props?.unRedemptionRightData?.compensationSum)
                )} ₪`}</span>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {Object.keys(props.lastDeposit).length ? (
        <div id="dashbaord-bottom" className="dashbaord-bottom">
          <h2 className="dashboard-bottom-title">
            {t("Dashboard.lastDeposit")}
          </h2>
          <div className="dashbaord-bottom-content">
            <div className="dashbaord-bottom-content-wrapper">
              <span className="dashbaord-bottom-content-label">
                {t("Dashboard.salaryMonth")}
              </span>
              <span className="dashbaord-bottom-content-value">
                {dateMonthFormat(props?.lastDeposit?.salaryDate)}
              </span>
            </div>
            <div className="dashbaord-bottom-content-wrapper">
              <span className="dashbaord-bottom-content-label">
                {t("Dashboard.depositDate")}
              </span>
              <span className="dashbaord-bottom-content-value">
                {dateDotFormat(props?.lastDeposit?.depositDate)}
              </span>
            </div>
            <div className="dashbaord-bottom-content-wrapper">
              <span className="dashbaord-bottom-content-label">
                {t("Dashboard.depositSum")}
              </span>
              <span className="dashbaord-bottom-content-value">
                {`${getTotalDeposit()} ₪`}{" "}
              </span>
            </div>
            <button
              className="dashboard-bottom-button"
              onClick={openDepositsPage}
              role="link"
            >
              <div className="dashboard-bottom-button-wrapper">
                <span>{t("Dashboard.watchAllDeposits")}</span>
                <img src={arrowLeftIcon} alt="arrow" />
              </div>
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DashboardPensionOption;
